/**
 * API client utilities
 */

import type { UpdateProjectCorrectionRequest } from '../../typings/api';
import { get, put } from '../redux/api';
import type {
  ListLicensesAPIRequest,
  ListLicensesAPIResponse,
  ReadLicenseAPIResponse,
} from '../../routes/licenses';
import { prepareRevisionDependencyForSaving } from '../helpers/revisions';
import { nuc } from '../utils';

const getLicenses = async (query: ListLicensesAPIRequest) => {
  const licensesResp = await get<ListLicensesAPIResponse>(
    '/api/licenses',
    false,
    query as Record<string, unknown>,
  );

  return licensesResp?.data;
};

const getLicense = async (id: string) => {
  const licenseResp = await get<ReadLicenseAPIResponse>(`/api/licenses/${id}`);

  return licenseResp?.data;
};

const updateProjectDirectLicenses = (locator, rawLicenses) => {
  const {
    dependencyProjectLocator,
    licenses,
  } = prepareRevisionDependencyForSaving(locator, { licenses: rawLicenses });

  const reqData: UpdateProjectCorrectionRequest = {
    licenses,
  };

  return put(`/api/projects/${nuc(dependencyProjectLocator)}/correction`, reqData);
};

export { getLicenses, getLicense, updateProjectDirectLicenses };
